// src/components/Gate.js
import React from "react";


export default function Gate({ allow = false, fallback = null, children }) {
  return allow ? <>{children}</> : <>{fallback}</>;
}